import React from "react";
import Select from "react-select";
import { Button } from "@wac-ui-dashboard/wac_component_library";

const AdvertisementFilterForm = ({
  formik,
  handleReset,
  addType,
}) => {
  let statusList = [
    {
      id: "0",
      label: "Inactive",
    },
    { id: "1", label: "Active" },
  ];
  return (
    <div>
      {/* Render form fields for the "Basic" tab */}

      <div className="input-wrap pro-mb-4">
        <label htmlFor="" className="pro-font-sm pro-mb-1 pro-fw-medium">
          Status
        </label>
        <Select
          id="status"
          placeholder={"Select"}
          className={"pro-input lg"}
          classNamePrefix="pro-input"
          // isMulti
          name="status"
          options={statusList}
          getOptionValue={(option) => option?.id}
          getOptionLabel={(option) => option?.label}
          value={statusList?.filter((m) => formik.values.status === m.id)}
          onChange={(value) => formik.setFieldValue("status", value?.id)}
        />
      </div>

      {/* <div className="input-wrap pro-mb-4">
        <label htmlFor="" className="pro-font-sm pro-mb-1 pro-fw-medium">
          Category
        </label>
        <Select
          id="category_id"
          placeholder={"Select"}
          className={"pro-input lg"}
          classNamePrefix="pro-input"
          isMulti
          name="category_id"
          options={categoryList}
          getOptionValue={(option) => option?._id}
          getOptionLabel={(option) => option?.name}
          value={categoryList?.filter((m) =>
            formik.values.category_id?.includes?.(m._id)
          )}
          onChange={(value) =>
            formik.setFieldValue(
              "category_id",
              value.map((v) => v._id)
            )
          }
        />
      </div> */}

      <div className="input-wrap pro-mb-4">
        <label htmlFor="" className="pro-font-sm pro-mb-1 pro-fw-medium">
          Type
        </label>
        <Select
          id="type"
          placeholder={"Select"}
          className={"pro-input lg"}
          classNamePrefix="pro-input"
          // isMulti
          name="type"
          options={addType}
          getOptionValue={(option) => option?._id}
          getOptionLabel={(option) => option?.name}
          value={addType?.filter(
            (m) =>
              // formik.values.type?.includes?.(m._id)
              formik.values.type === m?._id
          )}
          onChange={(value) => formik.setFieldValue("type", value?._id)}
        />
      </div>

      <div
        className={`col-12 pro-d-flex pro-justify-end ${"offcanvas-footer-sticky-btn"}`}
      >
        <Button className={"pro-btn-link lg pro-px-5"} onClick={handleReset}>
          Reset
        </Button>

        <Button
          className={"pro-btn-primary lg pro-ms-3"}
          type="submit"
          onClick={formik.handleSubmit}
        >
          Apply
        </Button>
      </div>
    </div>
  );
};

export default AdvertisementFilterForm;
